import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import { useTranslator } from '@jutro/locale';
import metadata from './BusinessInformationComponent.metadata.json5';
import styles from '../../../SpaAndWellCommonStyles.module.scss';

function BusinessInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BusinessInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated);
    const translator = useTranslator();

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        numofpartimEmpFie: {
            defaultValue: 0
        },
        ifyesdothelisyouasinsFie: {
            visible: !_.isUndefined(modelVM.value.doyourenspatoothwiuniFie) && modelVM.value.doyourenspatoothwiuniFie
        },
        pleadvavetimperwheempFie: {
            visible: !_.isUndefined(modelVM.value.istheanytimwhethewpreFie) && modelVM.value.istheanytimwhethewpreFie
        },
        comStrFie: {
            availableValues: _.filter(
                        modelVM.comStrFie.aspects.availableValues,
                        (filteredValue) => filteredValue.code !== 'other'
                    ).map((comStr) => ({
                code: comStr.code,
                name: translator({
                        id: comStr.name,
                        defaultMessage: comStr.name
                    })
            }))
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BusinessInformationComponent.propTypes = wizardProps;
export default withRouter(BusinessInformationComponent);
